import React, { Component } from 'react';
import logo from './../data-broker-logo-white.gif'; // Tell Webpack this JS file uses this image

class LoadingSection extends Component {
  render() {
    return (
      <section className="loading-section">
      <div class="lds-dual-ring"></div>
      </section>
    )
  }
}

export default LoadingSection
